export default "__VITE_ASSET__D71O1Rd2__"